export default function getCallbackFromProps(props) {
  return props.onSubscriptionRequest;
}



// WEBPACK FOOTER //
// ./src/widget/views/desktop/compact/components/player-overlay/ui-selectors/channel-overlay/paid-access/callback.js